import React from "react";

function Staff() {
  return (
    <>
      <h2 className="mt-32 text-6xl text-center">Meet our staff.</h2>
    </>
  );
}

export default Staff;
